import React, { useEffect, useState } from "react";
import { useLang } from "../lib/LangContext";

const ADMIN_WA = "6285220708569";

const FloatingWhatsApp = () => {
  const { lang } = useLang();
  const [visible, setVisible] = useState(false);
  const [showTip, setShowTip] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 300);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Auto-show tooltip once after 4s
  useEffect(() => {
    if (!visible) return;
    const t = setTimeout(() => setShowTip(true), 1200);
    const t2 = setTimeout(() => setShowTip(false), 6000);
    return () => {
      clearTimeout(t);
      clearTimeout(t2);
    };
  }, [visible]);

  const msg = encodeURIComponent(
    lang === "id"
      ? "Halo Adtree Go! Saya tertarik untuk bergabung sebagai creator."
      : "Hi Adtree Go! I'm interested in joining as a creator."
  );
  const href = `https://wa.me/${ADMIN_WA}?text=${msg}`;

  return (
    <div
      data-testid="floating-whatsapp"
      className={`fixed z-40 bottom-5 right-5 md:bottom-7 md:right-7 transition-all duration-500 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
    >
      <div className="relative">
        {showTip && (
          <div className="absolute bottom-full right-0 mb-3 whitespace-nowrap bg-black border border-brand-yellow text-white text-xs uppercase tracking-widest px-3 py-2 fade-up">
            {lang === "id" ? "Chat admin Adtree Go" : "Chat the Adtree Go team"}
            <span className="absolute -bottom-1.5 right-6 w-3 h-3 bg-black border-b border-r border-brand-yellow rotate-45" />
          </div>
        )}
        <a
          data-testid="floating-whatsapp-link"
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Chat via WhatsApp"
          className="group flex items-center gap-3 bg-brand-yellow text-black pl-3 pr-4 py-3 hover:bg-white transition-all hover:gap-4 glow-yellow"
        >
          <span className="relative flex items-center justify-center w-8 h-8 bg-black text-brand-yellow group-hover:bg-black/90">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true">
              <path d="M19.05 4.91A9.82 9.82 0 0 0 12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38a9.9 9.9 0 0 0 4.78 1.22h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.02ZM12.04 20.15h-.01a8.23 8.23 0 0 1-4.2-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.21 8.21 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.25-8.24 2.2 0 4.27.86 5.83 2.42a8.18 8.18 0 0 1 2.41 5.83c0 4.54-3.7 8.23-8.23 8.23Zm4.52-6.16c-.25-.12-1.47-.72-1.69-.81-.22-.08-.39-.12-.55.13s-.63.81-.77.97c-.14.17-.28.19-.53.07-.25-.13-1.05-.39-2-1.24-.74-.66-1.24-1.48-1.38-1.73-.14-.25-.02-.39.11-.51.12-.12.25-.31.37-.46.12-.15.16-.25.25-.42.08-.17.04-.31-.02-.43-.06-.12-.55-1.34-.76-1.83-.2-.48-.4-.42-.55-.42h-.47c-.16 0-.43.06-.65.31s-.86.84-.86 2.05c0 1.21.88 2.37 1 2.54.12.17 1.74 2.66 4.22 3.73.59.25 1.05.4 1.41.51.59.19 1.13.16 1.55.1.47-.07 1.47-.6 1.67-1.18.21-.58.21-1.07.15-1.18-.06-.1-.22-.17-.47-.29Z" />
            </svg>
            <span className="absolute -top-1 -right-1 w-2.5 h-2.5 bg-brand-yellow border border-black animate-pulse" />
          </span>
          <span className="font-anton uppercase tracking-widest text-xs md:text-sm">
            {lang === "id" ? "Chat WhatsApp" : "WhatsApp"}
          </span>
        </a>
      </div>
    </div>
  );
};

export default FloatingWhatsApp;
